import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import facilityService from 'src/services/apiServices/facilityService';
import { facilityAction } from 'src/redux/actions/constant';

const {
  PRE_GET_ASSIGNED_FACILITY_FAILURE,
  PRE_GET_ASSIGNED_FACILITY_SUCCESS,
  PRE_GET_ASSIGNED_FACILITY_REQUEST
} = facilityAction;

function* preGetFacilitiesData(action: any): SagaReturnType<any> {
  try {
    const response = yield call(facilityService.getPreAssignedFacilities, action.payload);
    if (response?.status === 200) {
      yield put({ type: PRE_GET_ASSIGNED_FACILITY_SUCCESS, payload: response });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: PRE_GET_ASSIGNED_FACILITY_FAILURE, payload: error });
  }
}

function* PreGetFacilityDropDownSaga() {
  yield takeEvery(PRE_GET_ASSIGNED_FACILITY_REQUEST, preGetFacilitiesData);
}

export default PreGetFacilityDropDownSaga;
